import React from "react";
import i18n from "../../../../constants/i18n";
import { ALL_USERS_AI_DESCRIPTIONS_HEADERS } from "../../../../constants/table-custom-headers/User";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getAIDescriptionsAllStore from "../../../../stores/developer-store/ai-descriptions-all-store";

const AIGeneratedDescriptionAllData = withLiteObserverAndTheme(() => {
  const rows = getAIDescriptionsAllStore().rows.get();
  const hasMore = getAIDescriptionsAllStore().hasMore.get();
  return (
    <React.Fragment>
      <Et3Table
        columns={ALL_USERS_AI_DESCRIPTIONS_HEADERS}
        rows={rows}
        title={i18n.get("AI_GENERATED_DESCRIPTION_ALL")}
        shouldBeFlagged={false}
        titleKey={"AI_GENERATED_DESCRIPTION_ALL"}
        emptyMessageKey={"NO_DESCRIPTION"}
      />
      {rows.length > 0 && hasMore && (
        <React.Fragment>
          <Et3Margin top={30} bottom={0} left={0} right={0} />
          <Et3Button
            isEnabled={true}
            onClick={async () => {
              getAIDescriptionsAllStore().loadMore();
            }}
            size="LARGE"
            text="LOAD_MORE"
            type="GET"
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
});

export default AIGeneratedDescriptionAllData;
